<template>
  <div>
    <el-row>
      <el-col>
        <el-form :inline="true" style="margin: 0;" v-model="searchForm" ref="searchForm" @keyup.enter.native="queryList">
          <el-form-item label="分类名称：" >
            <el-input size="medium" v-model="searchForm.NAME" clearable></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="margin-bottom: 10px">
    <el-button size="medium" type="primary" @click="queryList()">筛选</el-button>
    <el-button size="medium" @click="addCategory">新增</el-button>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe style="width: 100%;margin-top:20px">
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="ID" label="方案ID"></el-table-column>
          <el-table-column prop="NAME" label="备货方案"></el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-edit" @click="updateData(scope.row)">修改</el-button>
              <el-button type="text" size="small" @click="deleteCatalog(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog title="修改" center :visible.sync="updateFormVisible" width="500px" :close-on-click-modal="false">
      <el-form v-model="updateForm" ref="updateForm" size="small" >
        <el-form-item label="名称：" prop="NAME" :label-width="formLabelWidth">
          <label slot="label">备货方案名称：</label>
          <el-input v-model="updateForm.NAME" style="width:80%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="this.updateFormVisible = false">取 消</el-button>
          <el-button size="small" @click="submitUpdate()" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="新增产品备货方案" center :visible.sync="addFormVisible" width="400px" :close-on-click-modal="false">
      <el-form ref="addForm" v-model="addForm" :label-width="formLabelWidth" >
        <el-form-item label="方案名称：" prop="NAME">
          <el-input v-model="addForm.NAME" style="width:80%" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="this.addFormVisible = false">取 消</el-button>
        <el-button size="small" @click="submitAdd()" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { delCatalogFun } from '@/assets/api/skuManage';
import util from '@/assets/common/util';
import { frontEndFun } from '@/assets/api/frontFun';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      PAGE_ID: '12008', // 页面ID 一旦规定不要轻易改动
      formLabelWidth: '120px',
      updateForm: {
        NAME: '',
      },
      updateFormVisible: false,
      loading: false,
      searchForm: {
        NAME: '',
      },
      addFormVisible: false,
      addForm: {
        NAME: '',
      },
      tableData: [],
      currentPage: 1,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      totalCount: 0,
    };
  },
  created() {
    this.queryBeforeFun();
    this.queryTable();
  },
  computed: {
    FIRST_CATEGORY_DATA_CONDITION() {
      return this.$store.state.FIRST_CATEGORY_DATA_CONDITION;
    },
  },
  methods: {
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      frontEndFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 分页
    handleCurrentChange() {
      this.queryTable();
    },
    // 筛选
    queryList() {
      this.currentPage = 1;
      this.queryTable();
    },
    // 拉取
    queryTable() {
      const params = {
        SERVICE_ID: '10074',
        OTYPE: 13,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.NAME) {
        params.NAME = this.searchForm.NAME;
      }
      http.post(params).then((result) => {
        if (result[0].OP_ROLE.length !== 0) {
          this.tableData = result[0].OP_ROLE;
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 新增
    addCategory() {
      this.addFormVisible = true;
    },
    submitAdd() {
      if (!this.addForm.NAME) {
        this.$message.show({ text: '请填写备货方案名称', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '10074',
        OTYPE: 10,
        NAME: this.addForm.NAME,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '新增成功', type: 'success' });
        this.addFormVisible = false;
        this.addForm.NAME = '';
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.addFormVisible = false;
        this.queryTable();
      });
    },
    // 修改
    updateData(row) {
      this.updateForm = util.deepCopy(row);
      this.updateFormVisible = true;
    },
    // 确认修改
    submitUpdate() {
      if (!this.updateForm.NAME) {
        this.$message.show({ text: '请填写备货方案名称', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '10074',
        OTYPE: 12,
        NAME: this.updateForm.NAME,
        ID: this.updateForm.ID,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.updateFormVisible = false;
        this.updateForm = '';
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.updateFormVisible = false;
        this.updateForm = '';
        this.queryTable();
      });
    },
    // 删除
    deleteCatalog(row) {
      const params = {
        SERVICE_ID: '10074',
        OTYPE: 11,
        ID: row.ID,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '删除成功', type: 'success' });
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.queryTable();
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SKUManage/productStockingPlan.vue